<div *ngIf="showGlobalSearch" class="table-search-container">

    <input type="text" pInputText placeholder="Buscar..." (input)="filter($event)" />
</div>
<p-table #dt [value]="data" [rows]="rows" [paginator]="true" [rowsPerPageOptions]="rowsPerPageOptions"
    [ngClass]="{'dense-table': dense}"
    (onRowSelect)="onRowSelect($event)" [(selection)]="selection" (selectionChange)="onSelectionChange($event)"
    [globalFilterFields]="globalFilterFields" [sortField]="sortField" [sortOrder]="sortOrder"
    [scrollable]="scrollable" [scrollHeight]="scrollHeight">
    <ng-template pTemplate="header">
        <tr style="font-size: 12px" [ngClass]="{'no-gray': colorHeader}">
            <th *ngIf="showSelection" style="width: 4rem"><p-tableHeaderCheckbox /></th>
                <th></th>
            <th *ngFor="let col of columns" [pSortableColumn]="col.orderby ? col.field : ''">
                <div class="p-column-header-content">
                    <span>{{col.header}}</span>
                    <ng-container *ngIf="col.orderby">
                        <p-sortIcon field="{{col.field}}"></p-sortIcon>
                    </ng-container>
                    <ng-container *ngIf="col.filter && showFilters">
                        <p-columnFilter *ngIf="col.field" type="text" [field]="col.field" display="menu"
                            [placeholder]="'Buscar por ' + col.header + '...'" [matchMode]="'contains'" />
                    </ng-container>
                </div>
            </th>
        
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
        <tr style="font-size: 12px">
            <td *ngIf="showSelection"><p-tableCheckbox [value]="rowData"></p-tableCheckbox></td>
                        <td>
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <span class="material-symbols-outlined">more_vert</span>
                </button>
                <mat-menu #menu="matMenu">
                    <button *ngIf="optional" mat-menu-item (click)="onEditItem(rowData)">
                        <span class="material-symbols-outlined">edit</span>
                        <span>Editar</span>
                    </button>
                    <button *ngIf="DuplicateButton" mat-menu-item (click)="onClone(rowData)">
                        <span class="material-symbols-outlined">content_copy</span>
                        <span>Duplicar</span>
                    </button>
                    <button *ngIf="viewDetails" mat-menu-item (click)="onSeeDetails(rowData)">
                        <span class="material-symbols-outlined">list</span>
                        <span>Ver Detalle</span>
                    </button>
                    <button *ngIf="deleteButton" mat-menu-item (click)="onDeleteItems(rowData)">
                        <span class="material-symbols-outlined">delete</span>
                        <span>Eliminar</span>
                    </button>
                    <button *ngIf="retryProcess" mat-menu-item (click)="onRetry(rowData)">
                        <span class="material-symbols-outlined">Autorenew</span>
                        <span>reintentar</span>
                    </button>
                    <button *ngIf="configEdit" mat-menu-item (click)="onEditConfig(rowData)">
                        <span class="material-symbols-outlined">settings</span>
                        <span>Configurar</span>
                    </button>
                </mat-menu>
            </td>
            <td *ngFor="let col of columns">
                <ng-container *ngIf="col.field && rowData">
                    <ng-container *ngIf="customTemplates?.[col.field]; else default">
                        <ng-container
                            *ngTemplateOutlet="customTemplates[col.field]; context: { $implicit: getNestedValue(rowData, col.field) }">
                        </ng-container>
                    </ng-container>
                    <ng-template #default>
                        {{ getNestedValue(rowData, col.field) }}
                    </ng-template>
                </ng-container>
            </td>

        </tr>
    </ng-template>
    <!-- <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="{{columns.length + 2}}">Cargando datos...</td>
        </tr>
    </ng-template> -->
</p-table>
